// extracted by mini-css-extract-plugin
module.exports = {"imageButton":"gallery_imageButton__FQ1iY","videoPlayer":"gallery_videoPlayer__oLZWE","galleryList":"gallery_galleryList__b93lV"};